module.exports = __webpack_public_path__ + "img/feature-title-sm.4f6031ff.png";